<header [ngClass]="{'mobile-search-header': mobileSearchDisplay}">
    <div class="mobile-menu-button">
        <span class="material-symbols-rounded" *ngIf="!mobileNavOpen" (click)="menuOpen()">
            arrow_forward_ios
        </span>

        <span class="material-symbols-rounded menu-close-btn" *ngIf="mobileNavOpen" (click)="menuClose()">
            arrow_forward_ios
        </span>
    </div>


    <div class="mobile-header-logo" *ngIf="currentRoute == '/'">
        <div class="logo-container">
            <a *ngIf="theme == 'dark-mode'" routerLink="/"><img src="./assets/anddone-logo.svg" alt="AndDone logo"></a>
            <a *ngIf="theme == 'light-mode'" routerLink="/"><img src="./assets/AndDone-light-mode.svg"
                    alt="AndDone logo"></a>
        </div>
    </div>

    <div class="mobile-header-menu" *ngIf="currentRoute != '/'">
        <div class="select-wrapper">
            <select class="mobile-nav-dropdown form-select"
                [(ngModel)]="currentRoute"
                (change)="onNavChange($event)">

                <ng-container *ngFor="let navCategory of currentNav">
                    <ng-container *ngFor="let navGroup of navCategory.groups">

                        <optgroup label="{{ navGroup.group }}">
                            <option 
                            [value]="'/e/' + endpoint.slug" 
                            *ngFor="let endpoint of navGroup.endpoints">
                            {{endpoint.slug}}
                            </option>
                        </optgroup>

                    </ng-container>
                </ng-container>

            </select>
        </div>
    </div>

    <div class="header-left">
        <div class="logo-container" (click)="stopSearching()">
            <a *ngIf="theme == 'dark-mode'" routerLink="{{homepageRoute}}"><img src="./assets/anddone-logo.svg" alt="AndDone logo"></a>
            <a *ngIf="theme == 'light-mode'" routerLink="{{homepageRoute}}"><img src="./assets/AndDone-light-mode.svg" alt="AndDone logo"></a>
            <a routerLink="{{homepageRoute}}"><span class="api-bubble">{{contentType}}</span></a>
        </div>
    </div>

    <div class="search-container">
        <input type="text" id="searchInput" placeholder="QUICK SEARCH" [(ngModel)]="searchInput"
            (input)="submitSearchInput()" />
        <span class="material-symbols-rounded search-icon"> search </span>
        <span class="search-command">
            <span *ngIf="isMac" class="material-symbols-rounded command-icon">
                keyboard_command_key
            </span>
            <span *ngIf="!isMac" class=" command-icon">
                CTRL + 
            </span>
            <p class="search-command-key">K</p>
        </span>
    </div>

    <div class="header-right">
        <div class="header-nav">
            <ul (click)="stopSearching()">
                <li *ngIf="displayDocs && contentType === 'api'">
                    <a routerLink="/docs">Docs</a>
                </li>

                <li *ngIf="displayDocs && contentType === 'docs'">
                    <a routerLink="/">API</a>
                </li>

                <li *ngIf="!displayDocs">
                    <a target="_blank" href="https://docs.anddone.com/">Docs</a>
                </li>
                
                <li *ngIf="displayRecipes">
                    <a routerLink="/r">Recipes</a>
                </li>
                <li>
                    <a routerLink="/support">Support</a>
                </li>
                <li (mouseenter)="isClientLibraryFlyoutVisible = true"
                    (mouseleave)="isClientLibraryFlyoutVisible = false" class="hover">
                    Client Libraries
                    <div class="flyout-container" [class.visible]="isClientLibraryFlyoutVisible">
                        <div class="flyout-nav">
                            <div class="flyout-content">

                                <div class="client-libraries-main">
                                    <div *ngFor="let entry of librariesByType | keyvalue"
                                        class="client-library-type-wrapper">

                                        <h3 *ngIf="(entry.key === 'ClientLibrary')" class="client-library-heading">
                                            Client Libraries
                                        </h3>
                                        <h3 *ngIf="(entry.key !== 'ClientLibrary')" class="client-library-heading">
                                            AndDone FrameWorks
                                        </h3>

                                    <div class="client-library-row">
                                        <!-- Left Icon -->
                                        <div class="client-library-icon">
                                            <img *ngIf="(entry.key === 'ClientLibrary')"
                                                src="./assets/icons/clientLibraries/clientlibraries.svg"
                                                alt="Client Library Icon" class="client-library-title-img" />
                                            <img *ngIf="(entry.key !== 'ClientLibrary')"
                                                src="./assets/icons/clientLibraries/anddoneframeworks.svg"
                                                alt="Client Library Icon" class="client-library-title-img" />
                                        </div>

                                        <!-- Right Text & Links -->
                                        <div class="client-library-content">
                                            <ng-container *ngIf=" (entry.key === 'ClientLibrary')">
                                                <h5 class="client-library-title inline-block">Use our APIs in your
                                                    favorite language</h5>
                                                <p class="client-library-subtitle inline-block">Jump to the GitHub
                                                    repository for the libraries and installation
                                                    instructions. </p>
                                            </ng-container>
                                            <ng-container *ngIf=" (entry.key !== 'ClientLibrary')">
                                                <h5 class="client-library-title inline-block">See our Client Libraries
                                                    in action with these sample projects</h5>
                                                <p class="client-library-subtitle inline-block">Jump to the GitHub
                                                    repository, then follow the instructions to get started in minutes
                                                </p>
                                            </ng-container>
                                            <ul class="client-library-links">

                                                    <li *ngFor="let lib of entry.value">

                                                        <ng-container *ngIf="getThemeIcons(lib) as iconSet">
                                                            <a *ngIf="lib.RepositoryURL; else staticIcon" target="_blank"
                                                                [href]="lib.RepositoryURL" (mouseenter)="hoveredLib = lib"
                                                                (mouseleave)="hoveredLib = null">
                                                                <img [src]="hoveredLib === lib ? iconSet.Hover?.url : iconSet.Default?.url"
                                                                    [title]="lib.Language + ' Client Library'"
                                                                    [alt]="iconSet.Default?.alternativeText || lib.Language + ' Client Library'" />
                                                            </a>

                                                            <ng-template #staticIcon>
                                                                <span (mouseenter)="hoveredLib = lib"
                                                                    (mouseleave)="hoveredLib = null">
                                                                    <img [src]="hoveredLib === lib ? iconSet.Hover?.url : iconSet.Default?.url"
                                                                        [title]="lib.Language + ' Client Library (Unavailable)'"
                                                                        [alt]="iconSet.Default?.alternativeText || lib.Language + ' Client Library'"
                                                                        style="cursor: default; opacity: 0.7;" />
                                                                </span>
                                                            </ng-template>
                                                        </ng-container>


                                                    <ng-template *ngIf="lib && getThemeIcons(lib) as iconSet">
                                                        
                                                        <ng-container *ngIf="iconSet.Default?.url">
                                                            <a *ngIf="lib.RepositoryURL; else staticIcon"
                                                                target="_blank" [href]="lib.RepositoryURL"
                                                                (mouseenter)="hoveredLib = lib"
                                                                (mouseleave)="hoveredLib = null">
                                                                <img [src]="hoveredLib === lib ? iconSet.Hover?.url : iconSet.Default?.url"
                                                                    [title]="lib.Language + ' Client Library'"
                                                                    [alt]="iconSet.Default?.alternativeText || lib.Language + ' Client Library'" />
                                                            </a>

                                                                <ng-template #staticIcon>
                                                                    <span (mouseenter)="hoveredLib = lib"
                                                                        (mouseleave)="hoveredLib = null">
                                                                        <img [src]="hoveredLib === lib ? iconSet.Hover?.url : iconSet.Default?.url"
                                                                            [title]="lib.Language + ' Client Library (Unavailable)'"
                                                                            [alt]="iconSet.Default?.alternativeText || lib.Language + ' Client Library'"
                                                                            style="cursor: default; opacity: 0.7;" />
                                                                    </span>
                                                                </ng-template>
                                                            </ng-container>
                                                        </ng-template>
                                                    </li>

                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
                
                <li>
                    <label class="theme-toggle" title="Toggle theme">
                        <input type="checkbox" (click)="toggleTheme()">
                        <span class="theme-toggle-sr">Toggle theme</span>
                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" width="1em" height="1em"
                            class="theme-toggle__dark-side" fill="currentColor" viewBox="0 0 32 32">
                            <path
                                d="M16 .5C7.4.5.5 7.4.5 16S7.4 31.5 16 31.5 31.5 24.6 31.5 16 24.6.5 16 .5zm0 28.1V3.4C23 3.4 28.6 9 28.6 16S23 28.6 16 28.6z" />
                        </svg>
                    </label>
                </li>
            </ul>
        </div>
    </div>
    
    <div 
        *ngIf="contentType === 'api'"
        class="mobile-api-bubble">
        <a routerLink="/"><span class="api-bubble">API</span></a>
    </div>

    <div 
        *ngIf="contentType === 'docs'"
        class="mobile-api-bubble">
        <a routerLink="/docs"><span class="api-bubble">DOCS</span></a>
    </div>

</header>